import { useState, useEffect } from 'react';

/**
 * Interface definition based on the user's usage:
 * nativeData.battery.level
 * nativeData.battery.charging
 * nativeData.location
 */
export interface NativeData {
    battery: {
        level: number;
        charging: boolean;
    };
    location: any;
    [key: string]: any;
}

export const useNativeBridge = () => {
    const [nativeData, setNativeData] = useState<NativeData | null>(null);
    const [isNative, setIsNative] = useState(false);

    useEffect(() => {
        // Handler for messages coming from the Native WebView
        const handleMessage = (event: MessageEvent | any) => {
            try {
                const data = event.data;
                // Parse if it's a string (common in some bridge implementations)
                const parsed = typeof data === 'string' ? JSON.parse(data) : data;

                // Check if message is a native data update
                // We assume a standard format or just check if it has the expected fields
                if (parsed?.type === 'NATIVE_UPDATE' || (parsed?.battery && parsed?.location)) {
                    setNativeData(parsed.payload || parsed);
                    setIsNative(true);
                }
            } catch (error) {
                // Ignore parsing errors for unrelated messages
            }
        };

        // Listens for window messages (standard web)
        window.addEventListener('message', handleMessage);
        // Listens for document messages (specific to some React Native WebView implementations on Android)
        document.addEventListener('message', handleMessage as any);

        return () => {
            window.removeEventListener('message', handleMessage);
            document.removeEventListener('message', handleMessage as any);
        };
    }, []);

    return { nativeData, isNative };
};
